import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 448 512',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Grupo_5341" data-name="Grupo 5341" transform="translate(-960 -342)">
      <g id="Grupo_5340" data-name="Grupo 5340">
        <path
          id="user-solid"
          d="M224,256A128,128,0,1,0,96,128,127.99,127.99,0,0,0,224,256Zm89.6,32H296.9a174.075,174.075,0,0,1-145.8,0H134.4A134.435,134.435,0,0,0,0,422.4V464a48.012,48.012,0,0,0,48,48H400a48.012,48.012,0,0,0,48-48V422.4A134.435,134.435,0,0,0,313.6,288Z"
          transform="translate(960 342)"
          fill={fill}
        />
      </g>
    </g>
  </svg>
);

export default SVG;
